import React, {useState, useEffect} from 'react'
import { ContactList, Contacts, Discord, Email, FixedList, Glitch, Hamburger, Head, IconWrapper, Join, ListLi, LiWrapper, Logo, LogoWrapper, Menu, OptWrapper, Telegram, Youtube } from './Header.elements'

const Header = () => {
    const [click, setClick] = useState(false);
    const handleClick = () => setClick(!click);
    const [data, setData] = useState(null);

    const getData = () => {
      fetch('settings.json'
        , {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          }
        }
      ).then(function(response){
        return response.json();
      })
      .then(function(myJson) {
        console.log(myJson)
        setData(myJson.Components);
      });
    }
    useEffect(() => {
      getData()
    }, [])
    return (
        <Head>
            {
                data &&             
                <OptWrapper>
                    <LogoWrapper>
                        <Logo color="white" size="45px" />
                    </LogoWrapper>
                    <Hamburger open={click} onClick={handleClick} color="white" size="45px"/>
                    <Menu open={click}>
                        <FixedList>
                            <LiWrapper>
                                <ListLi to="/home"> Home </ListLi><br/>
                                <ListLi to="skills" spy={true} smooth={true} offset={50} duration={500}> Skills </ListLi><br/>
                                <ListLi to="/portfolio"> Portfolio </ListLi><br/>
                                <ListLi to="/prices"> Prices </ListLi><br/>
                                <ListLi to="/contacts"> Contact </ListLi><br/>
                            </LiWrapper>
                            <Contacts>
                                <Join>
                                    Join the conversation
                                </Join>
                                <ContactList>
                                    <IconWrapper href={data.Socials.discord}>
                                        <Discord color="white" size="18px"/>
                                    </IconWrapper>
                                    <IconWrapper href={data.Socials.youtube}>
                                        <Youtube color="white" size="18px"/>
                                    </IconWrapper>
                                    <IconWrapper href={data.Socials.telegram}>
                                        <Telegram color="white" size="18px"/>
                                    </IconWrapper>
                                    <IconWrapper href={data.Socials.email}>
                                        <Email color="white" size="18px"/>
                                    </IconWrapper>
                                </ContactList>
                            </Contacts>
                        </FixedList>
                    </Menu>
                </OptWrapper>
            }

        </Head>
    )
}

export default Header
